module.exports = __webpack_public_path__ + "static/media/Profesor.abfca03b.png";